import React from "react";
import "./NavigationBar.scss";
import {
    FacebookOutlined,
    FileOutlined,
    HomeOutlined,
    InfoCircleOutlined,
    MailOutlined,
    MoreOutlined,
} from "@ant-design/icons";
import {NavLink} from "react-router-dom";
import {Nullable} from "@data-force/app";
import {Translate} from "react-localize-redux";
import {connect} from "react-redux";
import {
    Button, Dropdown, Menu, Tooltip,
} from "antd";
import Logo from "../common/Logo/Logo";
import HistoryParams from "../../interfaces/historyParams";
import {getHistoryParams} from "../../utils/common";
import StoreState from "../../interfaces/store/storeState";

type Props = {
    pmUser: boolean
    facebookLink: string
    isMobile: boolean
};

class NavigationBar extends React.Component<Props> {
    private static readonly translationPath: string = "components.NavigationBar.NavigationBar";

    render() {
        const {pmUser, facebookLink, isMobile}: Props = this.props;
        const historyParams: Nullable<HistoryParams> = getHistoryParams();
        const {translationPath}: typeof NavigationBar = NavigationBar;

        return (
            <nav className="df-nav">
                <div className="df-nav-upper">
                    <div className="df-nav-logo-container">
                        <Logo dark={false}/>
                    </div>
                    <ul>
                        {!pmUser && (
                            <li className="df-nav-item">
                                <NavLink to={`/${historyParams?.idpId}/`} replace exact>
                                    <HomeOutlined aria-hidden/>
                                    <Translate id={`${translationPath}.home.text`}/>
                                </NavLink>
                            </li>
                        )}
                        <li className="df-nav-item">
                            <NavLink to={`/${historyParams?.idpId}/jobs`} replace>
                                <FileOutlined aria-hidden/>
                                <Translate id={`${translationPath}.jobs.text`}/>
                            </NavLink>
                        </li>
                        <li className="df-nav-item">
                            <NavLink to={`/${historyParams?.idpId}/faq`} replace>
                                <InfoCircleOutlined aria-hidden/>
                                <Translate id={`${translationPath}.faq.text`}/>
                            </NavLink>
                        </li>
                        <li className="df-nav-item">
                            <NavLink to={`/${historyParams?.idpId}/support`} replace>
                                <MailOutlined aria-hidden/>
                                <Translate id={`${translationPath}.support.text`}/>
                            </NavLink>
                        </li>
                        {isMobile && (
                            <li className="df-nav-item">
                                <Dropdown
                                    placement="topLeft"
                                    overlayClassName="df-social-links"
                                    overlay={(
                                        <Menu>
                                            <Menu.Item key="facebook_link">
                                                <a href={facebookLink} target="_blank" rel="noopener noreferrer">
                                                    <FacebookOutlined aria-hidden/>
                                                    <Translate id={`${translationPath}.fbPage.text`}/>
                                                </a>
                                            </Menu.Item>
                                        </Menu>
                                    )}
                                >
                                    <Button type="link">
                                        <span>
                                            <MoreOutlined rotate={90} aria-hidden/>
                                            <Translate id={`${translationPath}.more.text`}/>
                                        </span>
                                    </Button>
                                </Dropdown>
                            </li>
                        )}
                    </ul>
                </div>
                <div className="df-nav-lower">
                    <Tooltip
                        placement="topLeft"
                        arrowPointAtCenter
                        title={<Translate id={`${translationPath}.fbPage.text`}/>}
                    >
                        <a href={facebookLink} target="_blank" rel="noopener noreferrer">
                            <FacebookOutlined aria-hidden/>
                        </a>
                    </Tooltip>
                </div>
            </nav>
        );
    }
}

function mapStateToProps(state: StoreState): Props {
    return {
        pmUser: state.user.pmUser,
        facebookLink: state.serviceProperties.facebookLink,
        isMobile: state.mobile.isMobile,
    };
}

export default connect(mapStateToProps)(NavigationBar);
